import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { Link, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Slider from "react-slick";
import DesignItem from "../design/DesignItem";
import List from "../List";
import { processJonham } from "../../helpers";

import "./Landing.css";

class Landing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      marks: [],
      designs: [],
      origins: [],
      home: {},
      sIndex: 0,
      loading: true,
    };
  }

  componentDidMount() {
    axios
      .get("/api/home")
      .then((res) => {
        this.setState({
          marks: res.data.marks,
          designs: res.data.designs,
          origins: res.data.origins,
          home: res.data.home,
        });
      })
      .catch();
  }

  render() {
    const {
      orgTitle1,
      orgTitle2,
      rinymLabel,
      taskLabel,
      tmLabel,
      designLabel,
      originNameLabel,
      exhibitionLabel,
      rOrgLabel,
      rImageLabel,
      rDateLabel,
      originLabel,
      newLabel,
      relationLabel,
    } = this.props.labels;

    // console.log("this.props.labels = ", this.props.labels);

    let language = this.props.language;
    let search = this.props.search;

    var settings = {
      adaptiveHeight: true,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      draggable: false,
      arrows: false,
    };

    const { marks, designs, origins, home, sIndex } = this.state;
    const mark = marks[sIndex];
    const origin = origins.length > 0 ? origins[0] : null;
    const array = ["Kp", "En", "Cn", "Ru"];
    if (search != "")
      return (
        <div className="home">
          <div className="container pt-3 pb-5">
            <List></List>
          </div>
        </div>
      );
    else
      return (
        <div className="home">
          {/* <div className="slider"> */}
          <Slider {...settings}>
            {home.banners &&
              home.banners.map((url, index) => {
                return (
                  <img
                    key={index}
                    className="w-100"
                    src={`uploads/home/${url}`}
                    alt="intellectual property association korean trademark"
                  />
                );
              })}
          </Slider>
          {/* </div> */}
          <div className="container pt-5 pb-5">
            <div className="row">
              <div className="col-lg-7 col-md-12">
                <div className="h6 cheonrima" style={{ fontSize: "18px" }}>
                  {orgTitle1[language]}
                </div>
                <div className="h3 font-weight-bold pb-5">
                  {orgTitle2[language]}
                </div>
                <Typography
                  display="inline"
                  component="pre"
                  className="chongbong"
                  style={{
                    fontSize: "18px !important",
                    whiteSpace: "break-spaces",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: processJonham(home[`intro${array[language]}`]),
                  }}
                />

                <img
                  className="w-100 pt-5"
                  alt="dprk intellectual property association building"
                  src="./assets/building.jpg"
                ></img>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-start col-lg-5 col-md-12 mt-4 mt-md-4">
                <div className="mb-5 d-flex">
                  <img
                    alt="pen"
                    src="./assets/icon1.jpg"
                    style={{ width: "64px", height: "64px" }}
                  />
                  <div className="ml-4">
                    <div className="mb-2 h5 font-weight-bold">
                      {rinymLabel[language]}
                    </div>

                    <Typography
                      display="inline"
                      component="pre"
                      className="chongbong"
                      style={{
                        fontSize: "18px !important",
                        whiteSpace: "break-spaces",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: processJonham(home[`rinym${array[language]}`]),
                      }}
                    />
                  </div>
                </div>
                <div className="mb-5 d-flex">
                  <img
                    alt="note"
                    src="./assets/aim.png"
                    style={{ width: "64px", height: "64px" }}
                  />
                  <div className="ml-4">
                    <div className="mb-2 h5 font-weight-bold">
                      {taskLabel[language]}
                    </div>

                    <Typography
                      display="inline"
                      component="pre"
                      className="chongbong"
                      style={{
                        fontSize: "18px !important",
                        whiteSpace: "pre-line",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: processJonham(home[`task${array[language]}`]),
                      }}
                    />
                  </div>
                </div>
                {/* <div className="mb-5 d-flex">
                  <img
                    alt="tie"
                    src="./assets/related.png"
                    style={{ width: "64px", height: "64px" }}
                  />
                  <div className="ml-4">
                    <div className="mb-2 h5 font-weight-bold">
                      {relatedOrgLabel[language]}
                    </div>

                    <Typography
                      display="inline"
                      component="pre"
                      dangerouslySetInnerHTML={{
                        __html: processJonham(
                          home[`related${array[language]}`]
                        ),
                      }}
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="tradeAndDesign">
            <div className="container py-5">
              <div className="h3 font-weight-bold">{tmLabel[language]}</div>
              <Typography
                display="inline"
                component="pre"
                style={{ fontSize: "18px !important" }}
                dangerouslySetInnerHTML={{
                  __html: processJonham(home[`trade${array[language]}`]),
                }}
              />
              {mark && (
                <div className="row mt-4">
                  <div className="col-lg-12 col-md-12 d-flex justify-content-around flex-wrap mt-4">
                    {marks.map((mark, index) => {
                      const newDate = moment(mark.createdAt)
                        .add(7, "days")
                        .format("YYYY-MM-DD");
                      const today = moment().format("YYYY-MM-DD");
                      return (
                        <div
                          key={index}
                          className="landing-mark position-relative"
                        >
                          {today <= newDate && (
                            <div className="item-new-label">
                              {newLabel[language]}
                            </div>
                          )}
                          <div
                            // src={`uploads/trademark/${mark.imageUrl}`}
                            style={{
                              backgroundImage: `url(uploads/trademark/${mark.imageUrl})`,
                            }}
                            alt={mark[`markName${array[language]}`]}
                            className={`mark-img ${
                              sIndex === index ? "active" : ""
                            } `}
                            // onClick={() => {
                            //   this.setState({ sIndex: index });
                            // }}
                          ></div>
                          {/* <p className="text-center mark-img-name cheonrima cursor-default">
                            {mark[`markName${array[language]}`]}
                          </p> */}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div className="container py-5 bt-1-black-3">
              <div className="h3 font-weight-bold">{designLabel[language]}</div>
              <Typography
                display="inline"
                component="pre"
                style={{ fontSize: "18px !important" }}
                dangerouslySetInnerHTML={{
                  __html: processJonham(home[`design${array[language]}`]),
                }}
              />
              <div className="mt-5 d-flex flex-wrap align-items-center justify-content-center">
                {designs.map((design, index) => (
                  <DesignItem
                    key={`design${index}`}
                    design={design}
                    firstPage={true}
                  ></DesignItem>
                ))}
              </div>
            </div>
          </div>

          <div className="tradeAndDesign">
            <div className="container  py-5 bt-1-black-3">
              <div className="h3 font-weight-bold">
                {originNameLabel[language]}
              </div>
              <Typography
                display="inline"
                component="pre"
                style={{ fontSize: "18px !important" }}
                dangerouslySetInnerHTML={{
                  __html: processJonham(home[`origin${array[language]}`]),
                }}
              />
              {origin && (
                <div className="row mt-3">
                  <div className="col-lg-6 col-md-12 br-1-black-3">
                    {/* <video className="position-relative w-100 mt-3" controls>
                      <source
                        src={`uploads/origin/${origin.videoUrl}`}
                        type="video/mp4"
                      />
                      Your browser does not support HTML5 video.
                    </video> */}
                    <div
                      className="origin-img mt-4"
                      style={{
                        backgroundImage: `url(uploads/origin/${origin["imageUrl"]})`,
                      }}
                    ></div>
                    <div className="origin-region-name text-center">
                      {`${originLabel[language]}: ${
                        origin[`region${array[language]}`]
                      }`}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 mt-4 mt-md-4 mt-sm-4">
                    <div className="h4 font-weight-bold">
                      {origin[`name${array[language]}`]}
                    </div>
                    <blockquote className="blockquote">
                      <pre
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          whiteSpace: "break-spaces",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: processJonham(
                            origin[`desc${array[language]}`]
                          ),
                        }}
                      />
                    </blockquote>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className="exhibition"
            style={{
              backgroundImage:
                home.exchangeBgImage &&
                `url("uploads/home/${home.exchangeBgImage.slice(0, 2)[0]}")`,
            }}
          >
            <div className="container py-5 ">
              <div className="h3 font-weight-bold">
                {exhibitionLabel[language]}
              </div>
              <Typography
                display="inline"
                component="pre"
                style={{ fontSize: "18px !important", fontWeight: "bold" }}
                dangerouslySetInnerHTML={{
                  __html: processJonham(home[`ex${array[language]}`]),
                }}
              />
              <div className="d-flex flex-row justify-content-around algin-items-center mt-5 flex-wrap pb-3">
                <div
                  className="e1"
                  style={{
                    backgroundImage:
                      home.exchangeImages &&
                      `url("uploads/home/${
                        home.exchangeImages.slice(0, 1)[0]
                      }")`,
                  }}
                ></div>
                <div
                  className="e2"
                  style={{
                    backgroundImage:
                      home.exchangeImages &&
                      `url("uploads/home/${
                        home.exchangeImages.slice(1, 2)[0]
                      }")`,
                  }}
                ></div>
                <div
                  className="e3"
                  style={{
                    backgroundImage:
                      home.exchangeImages &&
                      `url("uploads/home/${
                        home.exchangeImages.slice(2, 3)[0]
                      }")`,
                  }}
                ></div>
              </div>

              <div className="d-flex justify-content-around align-items-center flex-wrap pt-3 exchange">
                <div
                  className="d-flex justify-content-between align-items-center ex-comment"
                  style={{ width: "405px !important" }}
                >
                  {/* <div className="ex-left"></div> */}
                  <div className="ex-title">
                    <span>{relationLabel[language]}</span>
                  </div>
                  <div className="ex-text">
                    <span>
                      {processJonham(home[`exchangeText${array[language]}`])}
                    </span>
                  </div>
                  {/* <div className="ex-right"></div> */}
                </div>
                <div
                  className="ip1"
                  style={{
                    backgroundImage:
                      home.exchangeImages &&
                      `url("uploads/home/${
                        home.exchangeImages.slice(3, 4)[0]
                      }")`,
                  }}
                ></div>
                {/* <div
                  className="ip2"
                  style={{
                    backgroundImage:
                      home.exchangeImages &&
                      `url("uploads/home/${
                        home.exchangeImages.slice(4, 5)[0]
                      }")`,
                  }}
                ></div> */}
              </div>
            </div>
          </div>
        </div>
      );
  }
}

Landing.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  language: state.profile.language,
  labels: state.labels,
  search: state.profile.search,
});

export default connect(mapStateToProps)(Landing);
